import React from "react";

import { Box, Typography } from "@mui/material";

import { theme } from "@/theme/customTheme";
import { colors } from "@/theme/overrides/colors";

type DurationProps = {
  duration: number;
};

const Duration: React.FC<DurationProps> = ({ duration }) => {
  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <Typography variant="h5" style={{ color: colors.primary }}>
        {duration}
      </Typography>
      <Typography
        variant="subtitle1"
        color="textSecondary"
        style={{ marginLeft: theme.spacing(2) }}
      >
        {duration > 1 ? "Days" : "Day"}
      </Typography>
    </Box>
  );
};

export default Duration;
